import { render, staticRenderFns } from "./devicecard.vue?vue&type=template&id=bd87092a&scoped=true"
import script from "./devicecard.vue?vue&type=script&lang=js"
export * from "./devicecard.vue?vue&type=script&lang=js"
import style0 from "./devicecard.vue?vue&type=style&index=0&id=bd87092a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd87092a",
  null
  
)

export default component.exports